import PropTypes from 'prop-types';
import { dataTablePropTypes } from '../../MDC/DataTable/_types';

export const personSearchPropTypes = {
	dataTable: PropTypes.shape({
		...dataTablePropTypes,
		indexed: PropTypes.bool,
		headers: PropTypes.oneOfType([
			dataTablePropTypes.headers,
			PropTypes.any,
		]),
	}).isRequired,
	displayHeader: PropTypes.shape(dataTablePropTypes.headers),
	errorMessage: PropTypes.string,
	inputOptions: PropTypes.node,
	isLoading: PropTypes.bool,
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	multiPerson: PropTypes.bool,
	onButtonClickedHandler: PropTypes.func.isRequired,
	onChipRemovedHandler: PropTypes.func,
	requestTarget: PropTypes.string,
	shouldAutoScroll: PropTypes.bool,
	value: PropTypes.string,
	warningMessage: PropTypes.string,
};
